import React from 'react'

type InferState<Store> = Store extends {state: unknown}
  ? Store['state']
  : unknown

export const createUseStore = <T extends {state: unknown} | undefined>(
  _StoreClass: new (...args: unknown[]) => T
) => {
  void _StoreClass
  const Context = React.createContext(undefined as T)
  const useStore = () => {
    const store = React.useContext(Context)
    return [store?.state as InferState<T>, store] as const
  }
  return [Context, useStore] as const
}
